// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag-home[data-v-28465c74]{height:100%;width:1500px}", ""]);
// Exports
module.exports = exports;
